/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TWebDeleteFavoritesModel = IModel<IWebDeleteFavoritesRequest, TWebDeleteFavoritesResponse>;

export interface IWebDeleteFavoritesRequest {
  /** Тип сделки **/
  dealType?: EDealType | null;
  /** Тип сущности **/
  entityType?: EEntityType | null;
}

export type TWebDeleteFavoritesResponse =
  | IWebDeleteFavoritesResponse400
  | IWebDeleteFavoritesResponse200
  | IWebDeleteFavoritesResponse204;

export interface IWebDeleteFavoritesResponse400 extends IModelResponse<IWebDeleteFavoritesResponseError> {
  statusCode: 400;
}

export interface IWebDeleteFavoritesResponse200 extends IModelResponse<IWebDeleteFavoritesResponse> {
  statusCode: 200;
}

export interface IWebDeleteFavoritesResponse204 extends IModelResponse<{}> {
  statusCode: 204;
}

export interface IWebDeleteFavoritesResponseError {
  errors: any[];
  message: string;
}

export interface IWebDeleteFavoritesResponse {}

export type TResponses = IWebDeleteFavoritesResponseError | IWebDeleteFavoritesResponse | {};

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EEntityType {
  /** Коммерческая **/
  Commercial = 'commercial',
  /** ЖК **/
  Newbuilding = 'newbuilding',
  /** Жилая **/
  Residential = 'residential',
  /** Загородка **/
  Suburban = 'suburban',
}

export interface IMappers<TResponse400, TResponse200, TResponse204> {
  400(response: IWebDeleteFavoritesResponseError): TResponse400;
  200(response: IWebDeleteFavoritesResponse): TResponse200;
  204(): TResponse204;
}
